////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const kioskProductionList = {
	resetDataKioskProductionList: () => ({
		type: ActionsTypes.RESET_DATA_KIOSK_PRODUCTION_LIST,
	}),
	getKioskProductionList: (
		filters = {},
		queryParams = {
			page: '0',
			size: '250',
			sort: 'owner.company.labelToDisplay',
			nameDir: 'asc',
			sort_2: 'labelToManufacturer',
			nameDir_2: 'asc',
		}
	) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_LIST,
		payload: {
			filters,
			queryParams,
		},
	}),
	getKioskProductionListSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_LIST_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskProductionListFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_LIST_FAILURE,
		payload: {
			error,
		},
	}),
	getInfosSimCard: (id) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD,
		payload: {
			id,
		},
	}),
	getInfosSimCardSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD_SUCCESS,
		payload: {
			data,
		},
	}),
	getInfosSimCardFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_SIMCARD_FAILURE,
		payload: {
			error,
		},
	}),
	getInfosBattery: (id) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY,
		payload: {
			id,
		},
	}),
	getInfosBatterySuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY_SUCCESS,
		payload: {
			data,
		},
	}),
	getInfosBatteryFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_BATTERY_FAILURE,
		payload: {
			error,
		},
	}),
	getInfosWS: (id) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS,
		payload: {
			id,
		},
	}),
	getInfosWSSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS_SUCCESS,
		payload: {
			data,
		},
	}),
	getInfosWSFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_PRODUCTION_INFOS_WS_FAILURE,
		payload: {
			error,
		},
	}),
}

export default kioskProductionList
